// extracted by mini-css-extract-plugin
export default {"imageWrapper":"e0-z","hovered":"f0-z","hoverImage":"g0-z","mainImage":"h0-z","imageNoBackground":"i0-z","fullSizeImage":"j0-z"};